<ng-select
  [multiple]="true"
  [items]="items"
  [(ngModel)]="company.departments"
  [trackByFn]="trackByFn"
  [closeOnSelect]="false"
  [clearable]="false"
  appendTo="body"
  bindLabel="name"
  class="department"
  [placeholder]="localizationConstants.DEPARTMENT_NO_FILTER_SET | translate">
  <ng-template
    ng-label-tmp
    let-item="item"
    let-clear="clear">
    <span class="ng-value-label">{{
      !!item.name
        ? item.fullName
          ? item.fullName + " - " + item.name
          : item.name
        : (localizationConstants.USERS_NO_DEPARTMENT_SELECTION | translate)
    }}</span>
    <span
      class="ng-value-icon right"
      (click)="clear(item)"
      >×</span
    >
  </ng-template>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-index="index"
    let-search="searchTerm">
    <span class="ng-value-label">{{
      !!item.name
        ? item.fullName
          ? item.fullName + " - " + item.name
          : item.name
        : (localizationConstants.USERS_NO_DEPARTMENT_SELECTION | translate)
    }}</span>
  </ng-template>
  <ng-template ng-header-tmp>
    <div class="o-grid--small">
      <div class="o-grid__item col-6">
        <button
          (click)="selectAll()"
          class="button--xs button-secondary">
          {{ localizationConstants.BUTTON_SELECT_ALL | translate }}
        </button>
      </div>
      <div class="o-grid__item col-6">
        <button
          (click)="unselectAll()"
          class="button--xs button-secondary">
          {{ localizationConstants.BUTTON_UNSELECT_ALL | translate }}
        </button>
      </div>
    </div>
  </ng-template>
  <!-- <ng-template ng-footer-tmp>
        Selected count: {{ company.departments?.length }}
    </ng-template> -->
</ng-select>
